import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLangPrefix from "../hooks/useLangPrefix";

const Header: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const prefix = useLangPrefix();
  const isEn = prefix === "/en";

  const dePath = isEn
    ? location.pathname.replace(/^\/en/, "") || "/"
    : location.pathname;
  const enPath = isEn
    ? location.pathname
    : location.pathname === "/"
    ? "/en"
    : `/en${location.pathname}`;

  return (
    <header className="header">
      <a href={isEn ? "/en" : "/"} className="logo">
        Thomas.
      </a>

      <div className="bx bx-menu" id="menu-icon"></div>
      <nav className="navbar">
        <a href={`${prefix}/#home`}>{t("nav.home")}</a>
        <a href={`${prefix}/#about`}>{t("nav.about")}</a>
        <a href={`${prefix}/#education`}>{t("nav.education")}</a>
        <a href={`${prefix}/#projects`}>{t("nav.products")}</a>
        <a href={`${prefix}/#skills`}>{t("nav.skills")}</a>
        <a href={`${prefix}/contact`}>{t("nav.contact")}</a>
        <span className="lang-switch" style={{ fontSize: "1.4rem" }}>
          <a
            href={dePath}
            style={{ fontWeight: !isEn ? 700 : 400, marginRight: "0.4rem" }}
          >
            DE
          </a>
          /
          <a
            href={enPath}
            style={{ fontWeight: isEn ? 700 : 400, marginLeft: "0.4rem" }}
          >
            EN
          </a>
        </span>

        <span className="active-nav"></span>
      </nav>
    </header>
  );
};

export default Header;
